import { useCallback } from 'react';

import { useLogoImage } from '@app/hooks/useLogoImage';
import { FIELD_TYPES, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { ExpertForm } from './ExpertForm';

const formFields = [
  { key: 'logo', type: FIELD_TYPES.IMAGE, message: 'Photo is required' },
  { key: 'first_name', type: FIELD_TYPES.MULTILINGUAL, message: 'First name is required' },
  { key: 'last_name', type: FIELD_TYPES.MULTILINGUAL, message: 'Last name is required' },
  { key: 'expert_roles', type: FIELD_TYPES.MULTILINGUAL, message: 'Role is required' },
  { key: 'email', type: FIELD_TYPES.EMAIL, message: 'Email is not valid', nonRequired: true },
];

// Passing in null for companyId in the API keeps the association unchanged
const nonRequiredFields = [
  { key: 'about', emptyValue: '', isMultilingual: true },
  { key: 'twitterurl', emptyValue: '', isMultilingual: false },
  { key: 'linked_inurl', emptyValue: '', isMultilingual: false },
  { key: 'company_id', emptyValue: null },
  { key: 'expertise_ids', emptyValue: [] },
];

export const CreateExpert = () => {
  const { logoImage, handleChangeImageLogo, transform } = useLogoImage(nonRequiredFields);

  const validate = useCallback(
    (values: GenericObject) => validateFormFields({ fields: formFields, values, image: logoImage }),
    [logoImage]
  );

  return (
    <CreateView resourceSingular="expert" validate={validate} transform={transform}>
      <ExpertForm expertLogo={logoImage} title="CREATE EXPERT" handleChangeExpertLogo={handleChangeImageLogo} />
    </CreateView>
  );
};
